import React from "react";
import { css } from "@emotion/react";
import { BRICKS } from "@titelmedia/bricks";

const Paragraph = BRICKS.elements.Paragraph;

const TextBlock = ({ text }) => (
  <div
    css={css`
      a {
        border-bottom: 1px solid black;
      }
      span {
        font-style: italic;
      }
      line-height: 1.4em;
      font-family: "univers-roman";

      @media (max-width: 767px) {
        margin-top: 15px;
      }
    `}
  >
    <Paragraph text={text} />
  </div>
);

const Image = ({ image }) => (
  <img src={image.fluid.src} srcSet={image.fluid.srcSet} />
);

const ImageText = props => {
  const { image, text, alignReverse } = props;

  return (
    <div
      css={css`
        max-width: 1200px;
        margin: 0 auto;
        position: relative;
        @media (max-width: 767px) {
          padding-bottom: 20px;
        }
      `}
    >
      <div
        css={css`
          display: flex;
          width: 100%;
          flex-direction: column;

          @media (min-width: 992px) {
            flex-direction: row;
          }
        `}
      >
        <div
          css={css`
            flex-basis: 0;
            flex-grow: 1;
            display: flex;
            padding: 0px 16px;
            height: ${(1 / image.fluid.aspectRatio) * 100}vw;

            @media (min-width: 992px) {
              order: ${alignReverse ? "1" : "0"};
              padding: 90px 60px;
              height: 100vh;
            }
          `}
        >
          <div
            css={css`
              width: 100%;
              height: 100%;

              position: relative;

              @media (min-width: 768px) {
                max-width: 520px;
                margin: 0 auto;
                padding: 0px 20px;
                margin-top: 45px;
              }

              @media (min-width: 992px) {
                margin-top: 0px;
                overflow: hidden;
                max-width: none;
              }
            `}
          >
            <div
              css={css`
                @media (min-width: 992px) {
                  position: absolute;
                  top: 50%;
                  left: 50%;
                  transform: translate3d(-50%, -50%, 0);
                  min-width: 100%;
                  min-height: 100%;
                  display: flex;

                  img {
                    object-fit: cover;
                  }
                }
              `}
            >
              <Image image={image} />
            </div>
          </div>
        </div>
        <div
          css={css`
            flex-basis: 0;
            flex-grow: 1;
            display: flex;
            align-items: center;
            justify-content: center;

            @media (min-width: 768px) {
              max-width: 520px;
              margin: 0 auto;
              margin-top: 45px;
            }

            @media (min-width: 992px) {
              margin-top: 0px;
              order: ${alignReverse ? "0" : "1"};
              padding: 90px 60px;
            }
          `}
        >
          <TextBlock text={text} />
        </div>
      </div>
    </div>
  );
};

export default ImageText;
